import { parseAndMigrate } from "../../../../app/configuration/parse";

export default defineNuxtPlugin((nuxtApp) => {
    const { variant } = useAppVariant()
    if (variant.value !== 'reader') return;
    
    console.log("Syncing Client Side with Server");
    const event = useRequestEvent();
    if (event?.context.config) {
        nuxtApp.payload.config = event.context.config;
        try {
            console.log(`Event context of type ${typeof event.context.config}`, event.context.config);
            const cirrusConfiguration = parseAndMigrate(event.context.config);
            if (cirrusConfiguration){
                useApplyCirrusConfig().generateFullConfiguration(cirrusConfiguration);
            }
        } catch (error){
            console.warn("An error occured whilst parsing and migrating configuration", error);
        }
    }
});